import { useEffect, useState } from "react";
import { API } from "../lib/apiClient";

// Fetches an auth-protected marketplace media path and shows it as a blob URL.
export function AuthImage({ path, alt, className, testid }) {
  const [src, setSrc] = useState("");
  useEffect(() => {
    let objectUrl;
    let active = true;
    (async () => {
      if (!path) return;
      try {
        const token = localStorage.getItem("artistos_token");
        const res = await fetch(`${API}/marketplace/media/${path}`, {
          headers: token ? { Authorization: `Bearer ${token}` } : {},
          credentials: "include",
        });
        if (!res.ok) return;
        const blob = await res.blob();
        objectUrl = URL.createObjectURL(blob);
        if (active) setSrc(objectUrl);
      } catch { /* ignore */ }
    })();
    return () => { active = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [path]);
  if (!src) return <div className={`bg-zinc-900 animate-pulse ${className || ""}`} data-testid={testid} />;
  return <img src={src} alt={alt || ""} className={className} data-testid={testid} />;
}
